import { createApp } from "vue";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import BootstrapVue3 from "bootstrap-vue-3";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import Vue3EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import { Tabs, Tab } from "vue3-tabs-component";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/inspinia/css/style.css";
import "./assets/inspinia/css/animate.css";
import "./assets/scss/style.scss";
import { registerLicense } from "@syncfusion/ej2-base";

const vuetify = createVuetify({
  components,
  directives,
});

library.add(fas, far, fab);
dom.watch();
registerLicense(
  "ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Udk1jW35bcXNcTmdV"
);
const app = createApp(App);
app
  .use(BootstrapVue3)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("EasyDataTable", Vue3EasyDataTable)
  .component("VueDatePicker", VueDatePicker)
  .component("tabs", Tabs)
  .component("tab", Tab)
  .component("QuillEditor", QuillEditor)
  .use(router)
  .use(store)
  .use(vuetify);

// Global pagination clamp: for any component exposing serverOptions and itemsAll
app.mixin({
  methods: {
    __clampPageGlobal() {
      try {
        if (!this.serverOptions) return;
        const itemsAll = Number(this.itemsAll ?? 0) || 0;
        const rowsPerPage = Number(this.serverOptions.rowsPerPage ?? 1) || 1;
        const max =
          itemsAll > 0 ? Math.max(1, Math.ceil(itemsAll / rowsPerPage)) : 1;
        const currentRaw = this.serverOptions.page;
        const current = Number(currentRaw ?? 1) || 1;
        const clamped = Math.min(Math.max(1, current), max);
        if (current !== clamped) {
          this.serverOptions.page = clamped;
        }
      } catch (e) {
        // ignore if component doesn't expose expected shape
      }
    },
  },
  watch: {
    itemsAll() {
      this.__clampPageGlobal();
    },
    "serverOptions.rowsPerPage"() {
      this.__clampPageGlobal();
    },
    "serverOptions.page"() {
      if (!this.serverOptions) return;
      const currentRaw = this.serverOptions.page;
      const current = Number(currentRaw ?? 1) || 1;
      if (current < 1) {
        this.serverOptions.page = 1;
      }
    },
  },
});

app.mount("#app");

// Ensure native context menu appears inside vue3-easy-data-table rows globally
document.addEventListener(
  "contextmenu",
  (e) => {
    const path = e.composedPath ? e.composedPath() : [];
    const target = e.target;
    const isInEasyTable =
      (target &&
        target.closest &&
        (target.closest(".vue3-easy-data-table__body") ||
          target.closest(".vue3-easy-data-table") ||
          target.closest(".easy-data-table__body") ||
          target.closest(".easy-data-table"))) ||
      path.some(
        (el) =>
          el &&
          el.classList &&
          (el.classList.contains("vue3-easy-data-table__body") ||
            el.classList.contains("vue3-easy-data-table") ||
            el.classList.contains("easy-data-table__body") ||
            el.classList.contains("easy-data-table"))
      );
    if (isInEasyTable) {
      e.stopPropagation();
      // Do not call preventDefault: we want the native menu
    }
  },
  true
);
